"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatus = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
require("@/components/common/icon");
require("@/components/common/spinner/spinner");
require("@/components/common/text/text");
const utils_1 = require("@/utils");
const taskStatusVariantTokens = {
    success: { '--task-status-icon-color': 'var(--foreground-success-color)' },
    warning: { '--task-status-icon-color': 'var(--foreground-warning-color)' },
    error: { '--task-status-icon-color': 'var(--foreground-danger-color)' },
};
/**
 * 진행률을 알 수 없는 작업의 현재 상태를 한 줄로 알린다.
 * 채울 막대가 없으므로 시도 횟수·경과 시간처럼 기다릴지 판단할 근거를 글로 준다.
 * 스스로 갱신되는 영역이라 host가 live region을 갖고, 안의 표식은 이름을 갖지 않는다.
 */
let TaskStatus = class TaskStatus extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'running';
        this.label = '';
        this.meta = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'status');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderIndicator()}
      <mm-text>${this.label}</mm-text>
      ${this.renderMeta()}
    `;
    }
    // 스피너도 아이콘도 옆 문구가 이미 말하는 것을 되풀이하므로 이름을 갖지 않는다.
    renderIndicator() {
        if (this.variant === 'running') {
            return (0, lit_1.html) `
        <mm-spinner aria-hidden="true"></mm-spinner>
      `;
        }
        return (0, lit_1.html) `
      <mm-icon name=${icon_names_1.STATUS_ICONS[this.variant]} aria-hidden="true"></mm-icon>
    `;
    }
    renderMeta() {
        if (!this.meta.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="meta">
        ${this.meta.map(item => (0, lit_1.html) `
            <mm-text>${item}</mm-text>
          `)}
      </div>
    `;
    }
};
TaskStatus.styles = (0, lit_1.css) `
    :host {
      --task-status-icon-color: currentColor;

      display: flex;
      align-items: center;
      gap: var(--space-2);
      color: var(--foreground-subtle-color);
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', taskStatusVariantTokens))}

    mm-icon {
      color: var(--task-status-icon-color);
    }

    .meta {
      display: flex;
      gap: var(--space-2);
    }

    .meta mm-text::before {
      content: '·';
      margin-inline-end: var(--space-2);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], TaskStatus.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TaskStatus.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], TaskStatus.prototype, "meta", void 0);
TaskStatus = __decorate([
    (0, decorators_js_1.customElement)('mm-task-status')
], TaskStatus);
exports.TaskStatus = TaskStatus;
//# sourceMappingURL=data:application/json;base64,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